/* =====================================================================
   DEKORZA – horlogeshop (lige-). Laadt alleen op de horlogetemplates.
   - Header: mobiel menu, winkelwagen-teller, lade openen
   - Productpagina: variantkeuze, galerij, toevoegen aan winkelwagen, vaste koopbalk
   - Duo: tweede horloge kiezen, beide variant-ID's samen naar /cart/add.js
   - Voor/na-schuifregelaar
   Geen externe libraries. Alle variant-ID's komen uit de pagina (Liquid).
   ===================================================================== */
(function () {
  'use strict';

  /* Spaanse horlogezone (templates lige-es…): body krijgt de klasse lige-es in layout/theme.liquid. */
  var LIGE_ES = document.body && document.body.classList.contains('lige-es');
  /* US-thema (27-9-2026): alles wat niet Spaans is, is Maison Lige US (Amerikaans Engels). */
  var LIGE_US = !LIGE_ES;

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  /* Vloeiend scrollen, met terugval: sommige browsers (of een verborgen tabblad)
     laten de animatie niet lopen; dan springen we direct naar de juiste plek. */
  function scrollX(el, left, smooth) {
    left = Math.max(0, Math.min(left, el.scrollWidth - el.clientWidth));
    if (smooth === false) { el.scrollTo({ left: left, behavior: 'instant' }); return; }
    var start = el.scrollLeft;
    el.scrollTo({ left: left, behavior: 'smooth' });
    setTimeout(function () { if (Math.abs(el.scrollLeft - start) < 2 && Math.abs(left - start) > 2) el.scrollTo({ left: left, behavior: 'instant' }); }, 420);
  }

  /* ---------- beeldkiezer ----------
     Vervangt een <select> visueel door een knop + lijst met foto's. Het <select>
     blijft (verborgen) bestaan en is de bron van de waarde: bij een keuze zetten we
     select.value en sturen we een change-event, zodat alle bestaande logica
     (variant-ID's, prijzen, winkelwagen) ongewijzigd werkt. Foto per optie komt uit
     data-thumb; de modelnaam uit de <optgroup> (alleen getoond bij meerdere modellen). */
  var openPicker = null;
  function closePicker() {
    if (!openPicker) return;
    openPicker.list.hidden = true;
    openPicker.btn.setAttribute('aria-expanded', 'false');
    openPicker.wrap.classList.remove('is-open');
    openPicker = null;
  }
  document.addEventListener('click', function (e) { if (openPicker && !openPicker.wrap.contains(e.target)) closePicker(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openPicker) { var b = openPicker.btn; closePicker(); b.focus(); } });

  var pickerId = 0;
  function enhanceSelect(sel) {
    if (!sel || sel._ligeRefresh) return;
    pickerId++;
    var multi = sel.querySelectorAll('optgroup').length > 1;
    var wrap = document.createElement('div');
    wrap.className = 'lige-pick ' + (sel.getAttribute('data-lige-pick-class') || '');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lige-pick__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', sel.getAttribute('aria-label') || '');
    btn.innerHTML = '<span class="lige-pick__img"><img alt="" width="60" height="60"></span><span class="lige-pick__txt"><span class="lige-pick__model"></span><span class="lige-pick__name"></span></span><span class="lige-pick__caret" aria-hidden="true"></span>';
    var list = document.createElement('ul');
    list.className = 'lige-pick__list';
    list.id = 'LigePick-' + pickerId;
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    btn.setAttribute('aria-controls', list.id);

    Array.prototype.forEach.call(sel.options, function (o, i) {
      var group = o.parentNode && o.parentNode.tagName === 'OPTGROUP' ? o.parentNode.label : '';
      var name = o.getAttribute('data-variant') || o.text;
      if (multi && group && name.indexOf(group + ' – ') === 0) name = name.slice(group.length + 3);
      var li = document.createElement('li');
      li.className = 'lige-pick__opt';
      li.setAttribute('role', 'option');
      li.setAttribute('data-index', i);
      li.tabIndex = -1;
      if (o.disabled) li.setAttribute('aria-disabled', 'true');
      var thumb = o.getAttribute('data-thumb');
      li.innerHTML = '<span class="lige-pick__img">' + (thumb ? '<img alt="" loading="lazy" width="60" height="60">' : '') + '</span><span class="lige-pick__txt">' + (multi && group ? '<span class="lige-pick__model"></span>' : '') + '<span class="lige-pick__name"></span></span>';
      if (thumb) li.querySelector('img').src = thumb;
      if (multi && group) li.querySelector('.lige-pick__model').textContent = group;
      li.querySelector('.lige-pick__name').textContent = name;
      li.setAttribute('data-model', multi ? group : '');
      li.setAttribute('data-name', name);
      list.appendChild(li);
    });

    function refresh() {
      var i = sel.selectedIndex;
      var o = sel.options[i];
      if (!o) return;
      var li = list.children[i];
      var img = btn.querySelector('.lige-pick__img img');
      var thumb = o.getAttribute('data-thumb');
      if (thumb) { img.src = thumb; img.hidden = false; } else { img.hidden = true; }
      btn.querySelector('.lige-pick__model').textContent = li ? li.getAttribute('data-model') : '';
      btn.querySelector('.lige-pick__name').textContent = li ? li.getAttribute('data-name') : o.text;
      Array.prototype.forEach.call(list.children, function (x, j) { x.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
    }
    function choose(i) {
      var o = sel.options[i];
      if (!o || o.disabled) return;
      if (sel.selectedIndex !== i) {
        sel.selectedIndex = i;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      refresh();
      closePicker();
      btn.focus();
    }
    function open() {
      if (openPicker && openPicker.wrap !== wrap) closePicker();
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      wrap.classList.add('is-open');
      openPicker = { wrap: wrap, btn: btn, list: list };
      /* binnen het scherm houden */
      list.style.left = '0px';
      var r = list.getBoundingClientRect();
      var over = r.right - (document.documentElement.clientWidth - 8);
      if (over > 0) list.style.left = (-over) + 'px';
      var cur = list.children[sel.selectedIndex];
      if (cur) { cur.focus({ preventScroll: true }); list.scrollTop = Math.max(0, cur.offsetTop - 8); }
    }
    btn.addEventListener('click', function (e) { e.preventDefault(); if (wrap.classList.contains('is-open')) closePicker(); else open(); });
    btn.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); } });
    list.addEventListener('click', function (e) { var li = e.target.closest('.lige-pick__opt'); if (li) choose(Number(li.getAttribute('data-index'))); });
    list.addEventListener('keydown', function (e) {
      var li = document.activeElement.closest && document.activeElement.closest('.lige-pick__opt');
      var i = li ? Number(li.getAttribute('data-index')) : sel.selectedIndex;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var step = e.key === 'ArrowDown' ? 1 : -1, n = i;
        do { n += step; } while (list.children[n] && list.children[n].getAttribute('aria-disabled') === 'true');
        if (list.children[n]) list.children[n].focus();
      } else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(i); }
      else if (e.key === 'Tab') closePicker();
    });

    sel.classList.add('lige-pick__native');
    sel.setAttribute('tabindex', '-1');
    sel.setAttribute('aria-hidden', 'true');
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(btn);
    wrap.appendChild(list);
    wrap.appendChild(sel);
    sel._ligeRefresh = refresh;
    refresh();
  }
  function refreshPicker(sel) { if (sel && sel._ligeRefresh) sel._ligeRefresh(); }

  /* ---------- geld ---------- */
  var moneyFormat = '{{amount_with_comma_separator}} €';
  var shopCurrency = '';
  function formatMoney(cents, format) {
    format = format || moneyFormat;
    cents = Number(cents) || 0;
    /* Andere valuta dan de winkelvaluta (bijv. USD in de markt Verenigde Staten): de Liquid-prijzen zijn al omgerekend,
       alleen het valutateken/de notatie moet kloppen → Intl met de actieve Shopify-valuta. */
    var cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (cur && shopCurrency && cur !== shopCurrency && window.Intl) {
      try { return new Intl.NumberFormat(LIGE_ES ? 'es-ES' : 'en-US', { style: 'currency', currency: cur }).format(cents / 100); } catch (e) {}
    }
    function withDelims(n, dec, thou, sep) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts[1] ? parts[0] + sep + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withDelims(cents, 2, ',', '.');
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_space_separator': return withDelims(cents, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return withDelims(cents, 2, "'", '.');
        default: return withDelims(cents, 2, '.', ',');
      }
    });
  }

  /* ---------- winkelwagen ---------- */
  function addItems(items) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var e = new Error(data && (data.description || data.message) || ('HTTP ' + r.status)); e.data = data; throw e; }
        return data;
      });
    });
  }

  function refreshCount() {
    return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-lige-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      })
      .catch(function () {});
  }

  /* Zelfde volgorde als de bestaande Dekorza-bundelcode: Kaching-lade, dan de
     lade van het thema (Impulse: cart:build + cart:open), anders naar /cart. */
  function openCart() {
    try {
      if (window.kachingCartApi && typeof window.kachingCartApi.refreshCart === 'function') {
        window.kachingCartApi.refreshCart();
        if (typeof window.kachingCartApi.openCart === 'function') window.kachingCartApi.openCart();
        return;
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
      document.documentElement.dispatchEvent(new CustomEvent('cart:open'));
    } catch (e) {
      window.location.href = root() + 'cart';
    }
  }

  /* ---------- header ---------- */
  function initHeader(hdr) {
    var burger = hdr.querySelector('[data-lige-burger]');
    var drawer = hdr.querySelector('[data-lige-drawer]');
    if (burger && drawer) {
      burger.addEventListener('click', function () {
        var open = burger.getAttribute('aria-expanded') === 'true';
        burger.setAttribute('aria-expanded', open ? 'false' : 'true');
        burger.setAttribute('aria-label', LIGE_ES ? (open ? 'Abrir el menú' : 'Cerrar el menú') : (open ? 'Open menu' : 'Close menu'));
        drawer.hidden = open;
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') { burger.click(); burger.focus(); }
      });
      window.matchMedia('(min-width: 750px)').addEventListener('change', function (mq) {
        if (mq.matches && burger.getAttribute('aria-expanded') === 'true') burger.click();
      });
    }
    hdr.querySelectorAll('[data-lige-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (window.theme && window.theme.settings && window.theme.settings.cartType === 'page') return;
        e.preventDefault();
        openCart();
      });
    });
    /* Headerhoogte doorgeven zodat de vaste productkolom eronder blijft. */
    var wrap = hdr.closest('.shopify-section');
    function setOffset() {
      var h = (wrap && getComputedStyle(wrap).position === 'sticky') ? wrap.offsetHeight : 0;
      document.documentElement.style.setProperty('--lige-header-offset', h + 'px');
    }
    setOffset();
    window.addEventListener('resize', setOffset, { passive: true });
  }

  /* ---------- productpagina ---------- */
  function LigeProduct(el) {
    this.el = el;
    var json = el.querySelector('[data-lige-product-json]');
    if (!json) return;
    try { this.data = JSON.parse(json.textContent); } catch (e) { return; }
    if (this.data.money_format) moneyFormat = this.data.money_format;
    if (this.data.shop_currency) shopCurrency = this.data.shop_currency;
    this.form = el.querySelector('[data-lige-form]');
    this.input = el.querySelector('[data-lige-variant-input]');
    this.atc = el.querySelector('[data-lige-atc]');
    this.error = el.querySelector('[data-lige-error]');
    this.track = el.querySelector('[data-lige-track]');
    this.thumbs = el.querySelector('[data-lige-thumbs]');
    this.mobile = window.matchMedia('(max-width: 989px)');
    var id = Number(this.input && this.input.value);
    this.variant = this.data.variants.filter(function (v) { return v.id === id; })[0] || this.data.variants[0];
    el.querySelectorAll('[data-lige-offer-select], [data-lige-slot1-select]').forEach(enhanceSelect);
    this.bindOptions();
    this.bindGallery();
    this.bindForm();
    this.bindSticky();
    this.offers = el.querySelector('[data-lige-offers]') ? new LigeOffers(el.querySelector('[data-lige-offers]'), this) : null;
    this.bundle = el.querySelector('[data-lige-bundle]') ? new LigeBundle(el.querySelector('[data-lige-bundle]'), this) : null;
  }

  LigeProduct.prototype.bindOptions = function () {
    var self = this;
    this.el.querySelectorAll('[data-lige-option-input]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var chosen = [];
        self.el.querySelectorAll('[data-lige-option]').forEach(function (fs) {
          var c = fs.querySelector('[data-lige-option-input]:checked');
          chosen.push(c ? c.value : null);
          var label = fs.querySelector('[data-lige-option-value]');
          if (label && c) label.textContent = c.value;
        });
        var match = self.data.variants.filter(function (v) {
          return v.options.every(function (o, i) { return chosen[i] === null || o === chosen[i]; });
        })[0];
        if (match) self.setVariant(match, 'options');
      });
    });
  };

  LigeProduct.prototype.setVariant = function (v, source) {
    if (!v) return;
    this.variant = v;
    var el = this.el;
    if (this.input) this.input.value = v.id;

    var now = el.querySelector('[data-lige-price-now]');
    var was = el.querySelector('[data-lige-price-was]');
    var save = el.querySelector('[data-lige-price-save]');
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    if (now) now.textContent = formatMoney(v.price);
    if (was) { was.hidden = !onSale; if (onSale) was.textContent = formatMoney(v.compare_at_price); }
    if (save) { save.hidden = !onSale; if (onSale) save.textContent = (save.getAttribute('data-label') || '') + formatMoney(v.compare_at_price - v.price); }

    if (this.atc) {
      var lbl = this.atc.querySelector('[data-lige-atc-label]');
      this.atc.disabled = !v.available;
      if (lbl) lbl.textContent = v.available ? this.atc.getAttribute('data-label-add') : this.atc.getAttribute('data-label-soldout');
    }

    /* opties in lijn brengen als de wissel van buitenaf komt (duo-slot 1) */
    if (source !== 'options') {
      el.querySelectorAll('[data-lige-option]').forEach(function (fs, i) {
        var val = v.options[i];
        fs.querySelectorAll('[data-lige-option-input]').forEach(function (inp) { inp.checked = inp.value === val; });
        var label = fs.querySelector('[data-lige-option-value]');
        if (label) label.textContent = val;
      });
    }

    if (v.media_id) this.showMedia(v.media_id, true);

    var stickyVar = el.querySelector('[data-lige-sticky-variant]');
    var stickyPrice = el.querySelector('[data-lige-sticky-price]');
    var stickyImg = el.querySelector('[data-lige-sticky-img] img');
    if (stickyVar && this.data.variants.length > 1) stickyVar.textContent = v.title;
    if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
    if (stickyImg && v.thumb) { stickyImg.src = v.thumb; stickyImg.removeAttribute('srcset'); }
    var stickyBtn = el.querySelector('[data-lige-sticky-atc]');
    if (stickyBtn) stickyBtn.disabled = !v.available;

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    if (this.bundle && source !== 'bundle') this.bundle.syncFirst(v);
    if (this.offers) this.offers.syncFirst(v);
  };

  /* ---------- galerij ---------- */
  LigeProduct.prototype.bindGallery = function () {
    var self = this;
    if (!this.track) return;
    var prev = this.el.querySelector('[data-lige-gal-prev]');
    var next = this.el.querySelector('[data-lige-gal-next]');
    function step(dir) {
      var w = self.track.clientWidth;
      var n = self.track.children.length;
      var i = Math.max(0, Math.min(n - 1, Math.round(self.track.scrollLeft / Math.max(1, w)) + dir));
      scrollX(self.track, i * w);
      var item = self.track.children[i];
      if (item) self.markThumb(item.getAttribute('data-media-id'));
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    if (this.thumbs) {
      this.thumbs.addEventListener('click', function (e) {
        var b = e.target.closest('[data-media-id]');
        if (b) self.showMedia(b.getAttribute('data-media-id'), false);
      });
    }
    var timer = null;
    this.track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (!self.mobile.matches) return;
        var i = Math.round(self.track.scrollLeft / Math.max(1, self.track.clientWidth));
        var item = self.track.children[i];
        if (item) self.markThumb(item.getAttribute('data-media-id'));
      }, 80);
    }, { passive: true });
  };

  LigeProduct.prototype.markThumb = function (mediaId) {
    if (!this.thumbs) return;
    var active = null;
    this.thumbs.querySelectorAll('[data-media-id]').forEach(function (t) {
      var on = t.getAttribute('data-media-id') === String(mediaId);
      t.classList.toggle('is-active', on);
      if (on) active = t;
    });
    if (active) {
      var box = this.thumbs;
      var left = active.offsetLeft - (box.clientWidth - active.clientWidth) / 2;
      scrollX(box, left);
    }
  };

  /* Mobiel: naar de foto schuiven. Ordinateur: de variantfoto bovenaan zetten,
     zoals op de referentie (gestapelde galerij). */
  LigeProduct.prototype.showMedia = function (mediaId, fromVariant) {
    if (!this.track) return;
    var item = this.track.querySelector('[data-media-id="' + mediaId + '"]');
    if (!item) return;
    if (this.mobile.matches) {
      var idx = Array.prototype.indexOf.call(this.track.children, item);
      scrollX(this.track, idx * this.track.clientWidth, !fromVariant);
    } else if (fromVariant) {
      if (this.track.firstElementChild !== item) this.track.insertBefore(item, this.track.firstElementChild);
      var img = item.querySelector('img');
      if (img) img.loading = 'eager';
      var top = this.track.getBoundingClientRect().top;
      if (top < 0) this.track.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      item.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    this.markThumb(mediaId);
  };

  /* ---------- toevoegen ---------- */
  LigeProduct.prototype.bindForm = function () {
    var self = this;
    if (!this.form) return;
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.addCurrent();
    });
  };

  LigeProduct.prototype.addCurrent = function () {
    var self = this;
    if (!this.variant || !this.atc) return;
    var offer = this.offers ? this.offers.selected() : null;
    var items = offer ? this.offers.items(offer) : [{ id: this.variant.id, quantity: 1 }];
    var code = offer ? offer.getAttribute('data-code') : '';
    if (!items.length || (!offer || Number(offer.getAttribute('data-qty')) === 1) && !this.variant.available) return;
    var lbl = this.atc.querySelector('[data-lige-atc-label]');
    var original = lbl ? lbl.textContent : '';
    this.atc.classList.add('is-busy');
    if (lbl) lbl.textContent = this.atc.getAttribute('data-label-busy') || original;
    if (this.error) this.error.hidden = true;
    addItems(items)
      .then(function () {
        /* Alleen als er in de formule een bestaande kortingscode is ingevuld. */
        if (code) return fetch(root() + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
      })
      .then(function () { return refreshCount(); })
      .then(function () { openCart(); })
      .catch(function (err) {
        if (self.error) self.error.hidden = false;
        if (window.console) console.error('[lige] toevoegen mislukt:', err);
      })
      .then(function () {
        self.atc.classList.remove('is-busy');
        if (lbl) lbl.textContent = original;
      });
  };

  /* ---------- vaste koopbalk ---------- */
  LigeProduct.prototype.bindSticky = function () {
    var self = this;
    var bar = this.el.querySelector('[data-lige-sticky]');
    if (!bar || !this.atc) return;
    var btn = bar.querySelector('[data-lige-sticky-atc]');
    if (btn) btn.addEventListener('click', function () { self.addCurrent(); });
    var shown = false, last = 0;
    /* Tonen zodra de gewone knop boven uit beeld is. Een eenvoudige scrollcontrole
       (max. ~12x per seconde) werkt ook waar IntersectionObserver hapert. */
    function check() {
      var show = self.atc.getBoundingClientRect().bottom < 0;
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (btn) btn.tabIndex = show ? 0 : -1;
    }
    window.addEventListener('scroll', function () {
      var now = Date.now();
      if (now - last < 80) { clearTimeout(self._stickyT); self._stickyT = setTimeout(check, 90); return; }
      last = now; check();
    }, { passive: true });
    check();
  };

  /* ---------- formules (offer cards) ----------
     Kaart met 1 horloge = de gekozen kleur op de pagina.
     Kaart met 2+ horloges = per horloge een keuzelijst (dit product + de blocks
     "Duo : montre proposée"). De hoofdknop voegt de gekozen kaart toe. */
  function LigeOffers(el, product) {
    var self = this;
    this.el = el;
    this.product = product;
    this.cards = Array.prototype.slice.call(el.querySelectorAll('[data-lige-offer]'));
    if (!this.cards.length) return;
    if (!el.querySelector('.lige-offer__input:checked')) this.cards[0].querySelector('.lige-offer__input').checked = true;
    this.cards.forEach(function (card) {
      card.querySelectorAll('[data-lige-offer-select]').forEach(function (sel) {
        if (sel.querySelector('option[value="' + product.variant.id + '"]')) sel.value = String(product.variant.id);
        sel.addEventListener('change', function () {
          self.thumb(sel); self.pick(card);
          /* Kaart met 1 horloge: de gekozen kleur wordt de kleur van de pagina (en omgekeerd via syncFirst). */
          if ((Number(card.getAttribute('data-qty')) || 1) === 1) {
            var id = Number(sel.value);
            var v = product.data.variants.filter(function (x) { return x.id === id; })[0];
            if (v) product.setVariant(v, 'offers');
          }
          self.price(card);
        });
        self.thumb(sel);
      });
      card.addEventListener('click', function (e) {
        if (e.target.closest('select, option, .lige-pick')) { self.pick(card); return; }
        self.pick(card);
      });
      card.querySelector('.lige-offer__input').addEventListener('change', function () { self.pick(card); });
      self.price(card);
    });
    this.mark();
  }

  LigeOffers.prototype.selected = function () {
    var inp = this.el.querySelector('.lige-offer__input:checked');
    return inp ? inp.closest('[data-lige-offer]') : this.cards[0];
  };

  LigeOffers.prototype.pick = function (card) {
    card.querySelector('.lige-offer__input').checked = true;
    this.mark();
  };

  LigeOffers.prototype.mark = function () {
    var sel = this.selected();
    this.cards.forEach(function (c) { c.classList.toggle('is-selected', c === sel); });
  };

  LigeOffers.prototype.thumb = function (sel) {
    var opt = sel.options[sel.selectedIndex];
    var box = sel.closest('.lige-offer__pick').querySelector('[data-lige-offer-thumb]');
    var src = opt && opt.getAttribute('data-thumb');
    if (!box || !src) return;
    var img = box.querySelector('img');
    if (!img) { img = document.createElement('img'); img.alt = ''; img.width = 40; img.height = 40; box.appendChild(img); }
    img.removeAttribute('srcset');
    img.src = src;
    refreshPicker(sel);
    var mini = sel.closest('.lige-offer__item') && sel.closest('.lige-offer__item').querySelector('[data-lige-offer-mini]');
    if (mini) {
      var m = mini.querySelector('img');
      if (!m) { m = document.createElement('img'); m.alt = ''; m.width = 32; m.height = 32; mini.appendChild(m); }
      m.removeAttribute('srcset');
      m.src = src;
    }
  };

  LigeOffers.prototype.price = function (card) {
    var qty = Number(card.getAttribute('data-qty')) || 1;
    var free = Number(card.getAttribute('data-free')) || 0;
    var v = this.product.variant;
    var price = 0, compare = 0, prices = [];
    if (qty === 1) {
      price = v.price;
      compare = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : v.price;
    } else {
      card.querySelectorAll('[data-lige-offer-select]').forEach(function (sel) {
        var o = sel.options[sel.selectedIndex];
        if (!o) return;
        var p = Number(o.getAttribute('data-price')) || 0;
        var c = Number(o.getAttribute('data-compare')) || 0;
        prices.push(p);
        price += p;
        compare += c > p ? c : p;
      });
    }
    /* 1+1: zoals de automatische Shopify-korting zijn de goedkoopste horloges gratis;
       de doorgestreepte prijs is dan de normale prijs van alle horloges samen. */
    if (free > 0 && prices.length > free) {
      prices.sort(function (a, b) { return a - b; });
      compare = price;
      for (var i = 0; i < free; i++) price -= prices[i];
    }
    var now = card.querySelector('[data-lige-offer-price]');
    var was = card.querySelector('[data-lige-offer-was]');
    if (now) now.textContent = formatMoney(price);
    var showWas = (free > 0 || card.getAttribute('data-show-compare') === 'true') && compare > price;
    if (was) { was.hidden = !showWas; if (showWas) was.textContent = formatMoney(compare); }
  };

  /* Kleurwissel op de pagina: horloge #1 van elke meervoudige kaart volgt mee. */
  LigeOffers.prototype.syncFirst = function (v) {
    var self = this;
    this.cards.forEach(function (card) {
      var first = card.querySelector('[data-lige-offer-select]');
      if (first && first.querySelector('option[value="' + v.id + '"]')) { first.value = String(v.id); self.thumb(first); }
      self.price(card);
    });
  };

  LigeOffers.prototype.items = function (card) {
    var qty = Number(card.getAttribute('data-qty')) || 1;
    if (qty === 1) return [{ id: this.product.variant.id, quantity: 1 }];
    var map = {}, order = [];
    card.querySelectorAll('[data-lige-offer-select]').forEach(function (sel) {
      var id = Number(sel.value);
      if (!id) return;
      if (!map[id]) { map[id] = 0; order.push(id); }
      map[id] += 1;
    });
    return order.map(function (id) { return { id: id, quantity: map[id] }; });
  };

  /* ---------- duo ---------- */
  function LigeBundle(el, product) {
    this.el = el;
    this.product = product;
    this.first = product.variant;
    this.second = null;
    this.page = 0;
    this.slot2 = el.querySelector('[data-lige-slot2]');
    this.chooser = el.querySelector('[data-lige-chooser]');
    this.track = el.querySelector('[data-lige-chooser-track]');
    this.cards = this.track ? Array.prototype.slice.call(this.track.querySelectorAll('.lige-card')) : [];
    this.perPage = Math.max(1, Number(this.chooser && this.chooser.getAttribute('data-per-page')) || 9);
    this.cta = el.querySelector('[data-lige-bundle-cta]');
    this.total = el.querySelector('[data-lige-bundle-total]');
    this.totalValue = el.querySelector('[data-lige-bundle-total-value]');
    this.error = el.querySelector('[data-lige-bundle-error]');
    this.bind();
    this.renderPage();
  }

  LigeBundle.prototype.bind = function () {
    var self = this;
    var sel1 = this.el.querySelector('[data-lige-slot1-select]');
    if (sel1) {
      sel1.addEventListener('change', function () {
        var id = Number(sel1.value);
        var v = self.product.data.variants.filter(function (x) { return x.id === id; })[0];
        if (v) { self.product.setVariant(v, 'bundle'); self.syncFirst(v); }
      });
    }
    /* Het raster is standaard dicht; het vak 'Choisissez votre deuxième montre' klapt het open en weer dicht. */
    this.el.querySelectorAll('[data-lige-open-chooser]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isPlaceholder = btn.classList.contains('lige-slot__placeholder');
        self.toggleChooser(isPlaceholder ? self.chooser.hidden : true);
      });
    });
    var prev = this.el.querySelector('[data-lige-chooser-prev]');
    var next = this.el.querySelector('[data-lige-chooser-next]');
    if (prev) prev.addEventListener('click', function () { self.page--; self.renderPage(); });
    if (next) next.addEventListener('click', function () { self.page++; self.renderPage(); });
    if (this.track) {
      this.track.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-lige-pick-model]');
        if (btn) self.chooseModel(btn.closest('.lige-card'));
      });
    }
    if (this.cta) this.cta.addEventListener('click', function () { self.add(); });
  };

  /* Raster met pagina's: één kaart per model. */
  LigeBundle.prototype.renderPage = function () {
    if (!this.track) return;
    var pages = Math.max(1, Math.ceil(this.cards.length / this.perPage));
    this.page = Math.max(0, Math.min(this.page, pages - 1));
    var from = this.page * this.perPage, to = from + this.perPage;
    this.cards.forEach(function (c, i) { c.hidden = i < from || i >= to; });
    var pager = this.el.querySelector('[data-lige-chooser-pager]');
    if (pager) pager.hidden = pages < 2;
    var info = this.el.querySelector('[data-lige-chooser-pageinfo]');
    if (info) info.textContent = (this.page + 1) + ' / ' + pages;
    var prev = this.el.querySelector('[data-lige-chooser-prev]');
    var next = this.el.querySelector('[data-lige-chooser-next]');
    if (prev) prev.disabled = this.page === 0;
    if (next) next.disabled = this.page >= pages - 1;
  };

  LigeBundle.prototype.toggleChooser = function (open) {
    if (!this.chooser) return;
    this.chooser.hidden = !open;
    this.el.querySelectorAll('[data-lige-open-chooser]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) {
      var sel = this.track.querySelector('.lige-card.is-selected');
      if (sel) { this.page = Math.floor(this.cards.indexOf(sel) / this.perPage); }
      this.renderPage();
      var first = this.track.querySelector('.lige-card:not([hidden]) [data-lige-pick-model]');
      if (first) first.focus({ preventScroll: true });
    }
  };

  LigeBundle.prototype.syncFirst = function (v) {
    this.first = v;
    var sel1 = this.el.querySelector('[data-lige-slot1-select]');
    if (sel1) { sel1.value = String(v.id); refreshPicker(sel1); }
    var img = this.el.querySelector('[data-lige-slot1-img] img');
    if (img && v.thumb) { img.src = v.thumb; img.removeAttribute('srcset'); }
    var price = this.el.querySelector('[data-lige-slot1-price]');
    if (price) price.textContent = formatMoney(v.price);
    this.update();
  };

  /* Model gekozen: in het tweede vak verschijnen naam + kleurkiezer van dat model. */
  LigeBundle.prototype.chooseModel = function (card) {
    var self = this;
    this.cards.forEach(function (c) { c.classList.toggle('is-selected', c === card); c.setAttribute('aria-selected', c === card ? 'true' : 'false'); });
    var btn = card.querySelector('[data-lige-pick-model]');
    var source = card.querySelector('[data-lige-model-variants]');
    if (!btn || !source) return;
    var box = this.slot2.querySelector('[data-lige-slot2-picker]');
    box.innerHTML = '';
    var sel = source.cloneNode(true);
    sel.hidden = false;
    sel.removeAttribute('hidden');
    sel.className = 'lige-slot__select';
    box.appendChild(sel);
    enhanceSelect(sel);
    this.secondTitle = btn.getAttribute('data-title');
    sel.addEventListener('change', function () { self.setSecond(sel); });
    this.slot2.classList.remove('is-empty');
    this.slot2.querySelector('.lige-slot__placeholder').hidden = true;
    this.slot2.querySelector('.lige-slot__filled').hidden = false;
    this.slot2.querySelector('[data-lige-slot2-name]').textContent = this.secondTitle;
    this.setSecond(sel);
    this.toggleChooser(false);
    var pickBtn = box.querySelector('.lige-pick__btn');
    if (pickBtn) pickBtn.focus({ preventScroll: true });
  };

  LigeBundle.prototype.setSecond = function (sel) {
    var o = sel.options[sel.selectedIndex];
    if (!o) { this.second = null; this.update(); return; }
    this.second = {
      id: Number(o.value),
      price: Number(o.getAttribute('data-price')) || 0,
      title: this.secondTitle,
      variant: o.getAttribute('data-variant') || '',
      thumb: o.getAttribute('data-thumb')
    };
    var imgBox = this.slot2.querySelector('[data-lige-slot2-img]');
    imgBox.innerHTML = '';
    if (this.second.thumb) {
      var img = document.createElement('img');
      img.src = this.second.thumb; img.alt = this.second.title || ''; img.width = 60; img.height = 60;
      imgBox.appendChild(img);
    }
    this.update();
  };

  LigeBundle.prototype.update = function () {
    var ready = !!(this.second && this.first && this.first.available);
    if (this.cta) {
      this.cta.disabled = !ready;
      this.cta.textContent = ready ? this.el.getAttribute('data-cta') : this.el.getAttribute('data-cta-disabled');
    }
    if (this.total) {
      this.total.hidden = !ready;
      if (ready) {
        var sum = this.first.price + this.second.price;
        var free = Number(this.el.getAttribute('data-free')) || 0;
        var pay = free > 0 ? Math.max(this.first.price, this.second.price) : sum;
        this.totalValue.textContent = formatMoney(pay);
        var was = this.el.querySelector('[data-lige-bundle-total-was]');
        if (was) { was.hidden = pay >= sum; was.textContent = formatMoney(sum); }
      }
    }
    this.renderAmounts();
  };

  /* Prijs per vak, zoals in de winkelwagen: bij 1+1 is het goedkoopste horloge doorgestreept met 'Offerte'. */
  LigeBundle.prototype.renderAmounts = function () {
    var a1 = this.el.querySelector('[data-lige-slot1-amount]');
    var a2 = this.el.querySelector('[data-lige-slot2-amount]');
    var freeLabel = this.el.getAttribute('data-free-label') || (LIGE_ES ? 'Gratis' : 'Free');
    var free = (Number(this.el.getAttribute('data-free')) || 0) > 0;
    function paid(el, cents) { if (el) el.innerHTML = '<span class="lige-slot__paid">' + formatMoney(cents) + '</span>'; }
    function gratis(el, cents) {
      if (!el) return;
      el.innerHTML = '<s>' + formatMoney(cents) + '</s><span class="lige-slot__free"></span>';
      el.querySelector('.lige-slot__free').textContent = freeLabel;
    }
    if (!this.first) return;
    if (!this.second) { paid(a1, this.first.price); if (a2) a2.innerHTML = ''; return; }
    if (!free) { paid(a1, this.first.price); paid(a2, this.second.price); return; }
    /* Shopify geeft het goedkoopste horloge gratis; bij gelijke prijs het tweede. */
    if (this.second.price <= this.first.price) { paid(a1, this.first.price); gratis(a2, this.second.price); }
    else { gratis(a1, this.first.price); paid(a2, this.second.price); }
  };

  LigeBundle.prototype.add = function () {
    var self = this;
    if (!this.second || !this.first) return;
    var items = this.first.id === this.second.id
      ? [{ id: this.first.id, quantity: 2 }]
      : [{ id: this.first.id, quantity: 1 }, { id: this.second.id, quantity: 1 }];
    this.cta.classList.add('is-busy');
    this.cta.textContent = this.el.getAttribute('data-busy');
    if (this.error) this.error.hidden = true;
    addItems(items)
      .then(function () { return refreshCount(); })
      .then(function () { openCart(); })
      .catch(function (err) {
        if (self.error) { self.error.textContent = self.el.getAttribute('data-error'); self.error.hidden = false; }
        if (window.console) console.error('[lige] duo toevoegen mislukt:', err);
      })
      .then(function () {
        self.cta.classList.remove('is-busy');
        self.update();
      });
  };

  /* ---------- voor / na ---------- */
  function initBeforeAfter(frame) {
    var range = frame.querySelector('[data-lige-ba-range]');
    if (!range) return;
    function set() { frame.style.setProperty('--ba-pos', range.value + '%'); }
    range.addEventListener('input', set);
    range.addEventListener('change', set);
    set();
    /* Alleen het bolletje in het midden verschuift de lijn; klikken of vegen elders
       op de foto doet niets. Het (onzichtbare) schuifbalkje blijft voor het toetsenbord. */
    var knob = frame.querySelector('.lige-ba__handle span');
    if (!knob) return;
    var dragging = false, offset = 0;
    function posFrom(x) {
      var r = frame.getBoundingClientRect();
      var p = ((x - offset - r.left) / r.width) * 100;
      return Math.max(0, Math.min(100, p));
    }
    knob.addEventListener('pointerdown', function (e) {
      dragging = true;
      var kr = knob.getBoundingClientRect();
      offset = e.clientX - (kr.left + kr.width / 2);
      try { knob.setPointerCapture(e.pointerId); } catch (err) {}
      frame.classList.add('is-dragging');
      e.preventDefault();
    });
    knob.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      range.value = posFrom(e.clientX);
      set();
    });
    function stop(e) {
      if (!dragging) return;
      dragging = false;
      frame.classList.remove('is-dragging');
      try { knob.releasePointerCapture(e.pointerId); } catch (err) {}
    }
    knob.addEventListener('pointerup', stop);
    knob.addEventListener('pointercancel', stop);
  }

  /* ---------- lopende tekstbalk ----------
     Vult de balk met genoeg kopieën om minstens 2 schermbreedtes te dekken en schuift
     precies één berichtengroep op. Zo ontstaat er nooit een leeg zwart stuk. */
  function initMarquee(ann) {
    var track = ann.querySelector('.lige-ann__track');
    if (!track || !ann.classList.contains('lige-ann--scroll')) return;
    var first = track.querySelector('.lige-ann__group');
    if (!first) return;
    function fill() {
      var w = first.getBoundingClientRect().width;
      if (!w) return;
      var need = Math.ceil((ann.clientWidth * 2) / w) + 1;
      var groups = track.querySelectorAll('.lige-ann__group');
      for (var i = groups.length; i < need; i++) {
        var c = first.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        track.appendChild(c);
      }
      track.style.setProperty('--la-shift', (-w) + 'px');
    }
    fill();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fill, 150); }, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fill);
  }

  /* ---------- winkelwagentimer ----------
     Echte timer: loopt hij af, dan wordt de winkelwagen geleegd (zoals de tekst belooft).
     Elke wijziging in de winkelwagen (toevoegen, aantal, verwijderen) zet hem opnieuw.
     De tijd staat boven de verzendregel in de Kaching-lade (alleen op horlogepagina's). */
  function initCartTimer(hdr) {
    var minutes = Number(hdr.getAttribute('data-cart-timer'));
    if (!minutes) return;
    var label = hdr.getAttribute('data-cart-timer-text') || (LIGE_ES ? 'Tu carrito caducará en' : 'Your cart expires in');
    var KEY = 'ligeCartTimerEnd', SIG = 'ligeCartTimerSig';
    var end = null, count = 0, expiring = false;
    function load() { try { end = Number(localStorage.getItem(KEY)) || null; } catch (e) { end = null; } }
    function save() { try { if (end) localStorage.setItem(KEY, String(end)); else localStorage.removeItem(KEY); } catch (e) {} }
    function reset() { end = Date.now() + minutes * 60000; save(); }
    function sync(c) { count = c; if (count > 0) { if (!end) reset(); } else { end = null; save(); } render(); }
    function fmt(ms) { var t = Math.max(0, Math.ceil(ms / 1000)); var m = Math.floor(t / 60), sec = t % 60; return (m < 10 ? '0' : '') + m + ':' + (sec < 10 ? '0' : '') + sec; }
    function render() {
      var txt = count > 0 && end ? fmt(end - Date.now()) : fmt(minutes * 60000);
      document.querySelectorAll('.kaching-cart__announcement-bar').forEach(function (bar) {
        var el = bar.parentNode && bar.parentNode.querySelector(':scope > .lige-cart-timer');
        if (!el) {
          el = document.createElement('div');
          el.className = 'lige-cart-timer';
          el.innerHTML = '<span></span> <b></b> <span aria-hidden="true">⏰</span>';
          el.firstChild.textContent = label;
          bar.parentNode.insertBefore(el, bar);
        }
        var b = el.querySelector('b');
        if (b.textContent !== txt) b.textContent = txt;
      });
    }
    function expire() {
      if (expiring) return; expiring = true;
      fetch(root() + 'cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
        .then(function () { end = null; save(); setSig(''); count = 0; refreshCount(); if (window.kachingCartApi && window.kachingCartApi.refreshCart) window.kachingCartApi.refreshCart(); })
        .catch(function () {})
        .then(function () { expiring = false; render(); });
    }
    /* Handtekening van de inhoud (product + aantal): alleen een echte wijziging zet de timer terug,
       niet de attribuut-updates die apps bij elke paginalading sturen. */
    function getSig() { try { return localStorage.getItem(SIG) || ''; } catch (e) { return ''; } }
    function setSig(v) { try { localStorage.setItem(SIG, v); } catch (e) {} }
    function fetchCart() { return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
    function sigOf(c) { return c.items.map(function (i) { return i.key + ':' + i.quantity; }).join('|'); }
    function fetchCount() { return fetchCart().then(function (c) { return c.item_count; }); }
    /* Wijzigingen in de winkelwagen opvangen (ook die van de Kaching-lade). */
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url) && !expiring) {
        p.then(function () { return fetchCart(); }).then(function (c) {
          var sig = sigOf(c);
          if (sig !== getSig()) { setSig(sig); if (c.item_count > 0) reset(); }
          sync(c.item_count);
        }).catch(function () {});
      }
      return p;
    };
    load();
    fetchCart().then(function (cart) {
      var c = cart.item_count, sig = sigOf(cart);
      count = c;
      if (c > 0 && end && end <= Date.now()) { expire(); return; }
      if (sig !== getSig()) { setSig(sig); if (c > 0) reset(); }
      sync(c);
    }).catch(function () {});
    setInterval(function () {
      if (count > 0 && end && end <= Date.now()) expire();
      render();
    }, 1000);
    new MutationObserver(function () { render(); }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- scoreregel onder de producttitel (uit lige-reviews) ---------- */
  function placeRating() {
    var slot = document.querySelector('[data-lige-rating-slot]');
    var line = document.querySelector('[data-lige-rating]');
    if (!slot || !line || slot.firstChild) return;
    line.hidden = false;
    slot.appendChild(line);
  }

  /* ---------- reviews: knop 'Afficher plus' op mobiel ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lige-rev-more]');
    if (!btn) return;
    var sec = btn.closest('[data-lige-reviews]');
    var grid = sec && sec.querySelector('.lige-rev__grid');
    if (grid) grid.classList.remove('is-collapsed');
  });

  /* ---------- winkelwagenlade: zichtbare horlogenaam (custom.display_name) ---------- */
  var ligeNames = null;
  function renameCartTitles() {
    if (ligeNames === null) {
      var src = document.getElementById('lige-display-names');
      try { ligeNames = src ? JSON.parse(src.textContent) : {}; } catch (err) { ligeNames = {}; }
    }
    document.querySelectorAll('.kaching-cart-item__title').forEach(function (el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var t = node.nodeValue.replace(/\s+/g, ' ').trim();
        if (t && Object.prototype.hasOwnProperty.call(ligeNames, t)) node.nodeValue = ligeNames[t];
      }
    });
    if (LIGE_ES) translateCartEs(); else translateCartUs();
    placeCartTrust();
  }
  /* Horlogezone (FR en ES): vertrouwensblok bovenin de Kaching-lade, direct onder de kop
     (LIGE-logo, balk "10 000+ clients satisfaits" / "clientes satisfechos", drie garanties). Beelden: assets/lige-cart-logo.png
     en lige-cart-avatars.png (ES: lige-cart-avatars-es.png); het pad komt van het eigen lige.js-script (zelfde themamap op het CDN).
     Idempotent: de observer roept dit vaak aan. */
  var ligeTrustBase = null;
  var LIGE_TRUST_ICONS = {
    shield: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5c0 4.6-3 8.4-7 10-4-1.6-7-5.4-7-10V6l7-3z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>',
    truck: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3.2v2.8h-7"/><circle cx="6.5" cy="17" r="1.8"/><circle cx="16.5" cy="17" r="1.8"/><path d="M1 9h4M1.5 12h3"/></svg>',
    globe: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c2.5 2.7 3.8 5.7 3.8 9s-1.3 6.3-3.8 9c-2.5-2.7-3.8-5.7-3.8-9S9.5 5.7 12 3z"/></svg>',
    lock: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10.5" width="14" height="10" rx="1.5"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/></svg>'
  };
  function placeCartTrust() {
    if (ligeTrustBase === null) {
      var s = document.querySelector('script[src*="/lige.js"]');
      ligeTrustBase = s ? s.getAttribute('src').replace(/\/lige\.js(\?.*)?$/, '/') : '';
    }
    if (!ligeTrustBase) return;
    document.querySelectorAll('.kaching-cart__header').forEach(function (h) {
      var n = h.nextElementSibling;
      if (n && n.classList.contains('lige-cart-trust')) return;
      var old = h.parentNode.querySelector(':scope > .lige-cart-trust');
      if (old) old.parentNode.removeChild(old);
      var box = document.createElement('div');
      box.className = 'lige-cart-trust';
      box.innerHTML = '<div class="lige-cart-trust__in">' +
        '<img class="lige-cart-trust__logo" src="' + ligeTrustBase + 'lige-cart-logo.png" width="490" height="221" alt="LIGE">' +
        (LIGE_ES
          ? '<div class="lige-cart-trust__proof"><img src="' + ligeTrustBase + 'lige-cart-avatars-es.png" width="136" height="60" alt="">' +
            '<span><b>10 000+</b> CLIENTES SATISFECHOS</span></div>' +
            '<ul class="lige-cart-trust__list">' +
            '<li>' + LIGE_TRUST_ICONS.shield + '<span>Garantía de 30 días</span></li>' +
            '<li>' + LIGE_TRUST_ICONS.truck + '<span>Envío gratuito en España</span></li>' +
            '<li>' + LIGE_TRUST_ICONS.lock + '<span>Pago seguro</span></li></ul></div>'
          : '<div class="lige-cart-trust__proof"><span><b>BUY 1, GET 1 FREE</b></span></div>' +
            '<ul class="lige-cart-trust__list">' +
            '<li>' + LIGE_TRUST_ICONS.shield + '<span>30-Day Money-Back Guarantee</span></li>' +
            '<li>' + LIGE_TRUST_ICONS.truck + '<span>Free Shipping</span></li>' +
            '<li>' + LIGE_TRUST_ICONS.lock + '<span>Secure Checkout</span></li></ul></div>');
      h.parentNode.insertBefore(box, h.nextSibling);
    });
  }
  /* Spaanse horlogezone: vaste Franse teksten van de Kaching-lade naar het Spaans (alleen tekstknopen, alleen body.lige-es). */
  var LIGE_CART_ES = [
    [/^Mon panier/, 'Mi carrito'], [/^Vous économisez/, 'Ahorras'], [/^GRATUIT$/, 'GRATIS'], [/^Réductions$/, 'Descuentos'],
    [/^Sous-total$/, 'Subtotal'], [/^Votre panier est vide.?$/, 'Tu carrito está vacío'],
    [/^Continuer vos achats$/, 'Seguir comprando'],
    [/^Félicitations ! Vous bénéficiez de la livraison gratuite.?$/, '¡Ya tienes envío gratis!']
  ];
  /* Kaching's (Engelse) toegankelijkheidslabels in de lade */
  var LIGE_CART_ES_ARIA = [
    [/^Close cart$/, 'Cerrar carrito'], [/^Decrease quantity$/, 'Reducir cantidad'], [/^Increase quantity$/, 'Aumentar cantidad'],
    [/^Quantity$/, 'Cantidad'], [/^Proceed to Checkout$/i, 'Finalizar pedido'], [/^Remove (.+) from cart$/, 'Eliminar $1 del carrito']
  ];
  function translateCartEs() {
    document.querySelectorAll('.kaching-cart').forEach(function (root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), node;
      while ((node = walker.nextNode())) {
        var v = node.nodeValue, t = v.trim();
        if (!t) continue;
        /* Afrekenknop: altijd "Finalizar pedido • <laatste bedrag>" (idempotent; Kaching werkt het bedrag in dezelfde tekstknoop bij) */
        if (/^(Passer au paiement|Finalizar compra|Finalizar pedido)/.test(t)) {
          var seg = t.split('•'), amount = seg.length > 1 ? seg[seg.length - 1].trim() : '';
          var want = 'Finalizar pedido' + (amount ? ' • ' + amount : '');
          if (t !== want) node.nodeValue = want;
          continue;
        }
        for (var i = 0; i < LIGE_CART_ES.length; i++) {
          if (LIGE_CART_ES[i][0].test(t)) { var nt = t.replace(LIGE_CART_ES[i][0], LIGE_CART_ES[i][1]); var nv = v.replace(t, function () { return nt; }); if (nv !== v) node.nodeValue = nv; break; }
        }
      }
      root.querySelectorAll('[aria-label]').forEach(function (el) {
        var a = el.getAttribute('aria-label');
        for (var j = 0; j < LIGE_CART_ES_ARIA.length; j++) {
          if (LIGE_CART_ES_ARIA[j][0].test(a)) { var na = a.replace(LIGE_CART_ES_ARIA[j][0], LIGE_CART_ES_ARIA[j][1]); if (na !== a) el.setAttribute('aria-label', na); break; }
        }
      });
    });
  }
  /* US-thema: vaste (Franse) Kaching-teksten, varianten en productnamen in de lade naar Amerikaans Engels.
     Woordenboek voor varianten/namen: #lige-us-dict (snippet lige-us-dict, uit dezelfde bron als de productpagina). */
  var LIGE_CART_US = [
    [/^Mon panier/, 'Your Cart'], [/^Panier$/, 'Your Cart'], [/^Vous économisez/, 'You Save'], [/^Économisez/, 'Save'], [/^GRATUIT$/i, 'FREE'], [/^Gratuit$/, 'Free'],
    [/^Réductions?$/, 'Discounts'], [/^Sous-total$/, 'Subtotal'], [/^Total$/, 'Total'], [/^Livraison$/, 'Shipping'], [/^Quantité$/, 'Quantity'], [/^Supprimer$/, 'Remove'],
    [/^Votre panier est vide.?$/, 'Your cart is empty'], [/^Continuer (vos|mes) achats$/, 'Continue Shopping'],
    [/^Félicitations ! Vous bénéficiez de la livraison gratuite.?$/, 'You’ve unlocked free shipping!'],
    [/^Couleur ?: ?/, 'Color: ']
  ];
  var ligeUsDict = null;
  function usDict() {
    if (ligeUsDict === null) {
      var src = document.getElementById('lige-us-dict');
      try { ligeUsDict = src ? JSON.parse(src.textContent) : {}; } catch (err) { ligeUsDict = {}; }
    }
    return ligeUsDict;
  }
  function usWord(t) {
    var d = usDict();
    if (Object.prototype.hasOwnProperty.call(d, t)) return d[t];
    /* "Couleur : X" / "Kleur / Titel" varianten */
    var m = t.match(/^(Couleur ?: ?)(.+)$/);
    if (m && Object.prototype.hasOwnProperty.call(d, m[2])) return 'Color: ' + d[m[2]];
    return null;
  }
  function translateCartUs() {
    document.querySelectorAll('.kaching-cart').forEach(function (root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), node;
      while ((node = walker.nextNode())) {
        var v = node.nodeValue, t = v.replace(/\s+/g, ' ').trim();
        if (!t) continue;
        /* Afrekenknop: altijd "Checkout • <laatste bedrag>" (idempotent; Kaching werkt het bedrag in dezelfde tekstknoop bij) */
        if (/^(Passer au paiement|Paiement|Commander|Checkout|Proceed to checkout)/i.test(t)) {
          var seg = t.split('•'), amount = seg.length > 1 ? seg[seg.length - 1].trim() : '';
          var want = 'Checkout' + (amount ? ' • ' + amount : '');
          if (t !== want) node.nodeValue = want;
          continue;
        }
        var w = usWord(t);
        if (w !== null) { if (w !== t) node.nodeValue = v.replace(v.trim(), w); continue; }
        for (var i = 0; i < LIGE_CART_US.length; i++) {
          if (LIGE_CART_US[i][0].test(t)) { var nt = t.replace(LIGE_CART_US[i][0], LIGE_CART_US[i][1]); var nv = v.replace(v.trim(), function () { return nt; }); if (nv !== v) node.nodeValue = nv; break; }
        }
      }
    });
  }
  var ligeRenameQueued = false;
  new MutationObserver(function () {
    if (ligeRenameQueued) return;
    ligeRenameQueued = true;
    setTimeout(function () { ligeRenameQueued = false; renameCartTitles(); }, 0);
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  /* ---------- Spaanse zone: afrekenen in het Spaans ----------
     De lige-es-pagina's draaien op de standaard-URL (taal fr); Kaching stuurt naar
     Shopify.routes.root + 'checkout' en de checkout volgt die taal (fr-es). Op het moment
     van afrekenen zetten we de root op /es/, zodat Kaching naar /es/checkout gaat (es-es).
     Alleen body.lige-es; de Franse zone raakt dit niet. */
  if (LIGE_ES) {
    var hookEsCheckout = function () {
      var api = window.kachingCartApi;
      if (!api || typeof api.setCheckoutButtonClickHandler !== 'function') return false;
      api.setCheckoutButtonClickHandler(function () {
        try {
          var r = window.Shopify && window.Shopify.routes;
          var cur = String((r && r.root) || '/');
          if (r && cur.slice(-4) !== '/es/') r.root = (cur.charAt(cur.length - 1) === '/' ? cur : cur + '/') + 'es/';
        } catch (e) {}
        return true;
      });
      return true;
    };
    if (!hookEsCheckout()) {
      var esTries = 0, esTimer = setInterval(function () { if (hookEsCheckout() || ++esTries > 80) clearInterval(esTimer); }, 250);
    }
  }

  /* ---------- upsell in de winkelwagenlade (Kaching) ----------
     Gegevens uit #lige-upsell (lige-header). Het blok staat onder de artikelen; Kaching
     tekent de lade soms opnieuw, dan zet de observer het blok terug. */
  var ligeUp = null, ligeUpQueued = false, ligeUpBusy = false;
  function upsellData() {
    if (ligeUp === null) {
      var src = document.getElementById('lige-upsell');
      try { ligeUp = src ? JSON.parse(src.textContent) : false; } catch (err) { ligeUp = false; }
    }
    return ligeUp;
  }
  function upsellCartIds() {
    var ids = {};
    try {
      var c = window.kachingCartApi && window.kachingCartApi.getCartData && window.kachingCartApi.getCartData();
      if (c && c.items) c.items.forEach(function (i) { ids[String(i.variant_id || i.id)] = true; });
    } catch (e) {}
    return ids;
  }
  function upsellArrows(box) {
    var t = box.querySelector('[data-lige-up-track]');
    var max = t.scrollWidth - t.clientWidth - 2;
    box.querySelector('[data-lige-up-prev]').disabled = t.scrollLeft <= 2;
    box.querySelector('[data-lige-up-next]').disabled = t.scrollLeft >= max;
    box.classList.toggle('lige-upsell--static', max <= 0);
  }
  function renderUpsell() {
    var data = upsellData();
    if (!data || !data.items || !data.items.length) return;
    document.querySelectorAll('.kaching-cart__inner').forEach(function (drawer) {
      /* één container per artikel: het blok hoort onder het laatste artikel */
      var lists = drawer.querySelectorAll('.kaching-cart-item-container');
      var list = lists.length ? lists[lists.length - 1] : null;
      var box = drawer.querySelector('.lige-upsell');
      if (!list) { if (box) box.remove(); return; }
      var inCart = data.hideInCart ? upsellCartIds() : {};
      var items = data.items.filter(function (it) { return !inCart[String(it.id)]; });
      if (!items.length) { if (box) box.remove(); return; }
      var sig = items.map(function (it) { return it.id; }).join(',');
      if (box && box.previousElementSibling === list && box.getAttribute('data-sig') === sig) return;
      if (box) box.remove();
      box = document.createElement('div');
      box.className = 'lige-upsell';
      box.setAttribute('data-sig', sig);
      box.innerHTML = '<p class="lige-upsell__title"></p><div class="lige-upsell__wrap">' +
        '<button type="button" class="lige-upsell__arrow" aria-label="' + (LIGE_ES ? 'Anterior' : 'Previous') + '" data-lige-up-prev>&larr;</button>' +
        '<div class="lige-upsell__track" data-lige-up-track></div>' +
        '<button type="button" class="lige-upsell__arrow" aria-label="' + (LIGE_ES ? 'Siguiente' : 'Next') + '" data-lige-up-next>&rarr;</button></div>';
      box.querySelector('.lige-upsell__title').textContent = data.heading || '';
      var track = box.querySelector('[data-lige-up-track]');
      items.forEach(function (it) {
        var card = document.createElement('div');
        card.className = 'lige-upsell__card';
        card.innerHTML = '<a class="lige-upsell__img" tabindex="-1" aria-hidden="true"></a><a class="lige-upsell__name"></a>' +
          '<p class="lige-upsell__price"><s></s><span></span></p>' +
          '<button type="button" class="lige-upsell__add" data-lige-up-add></button>';
        var a = card.querySelector('.lige-upsell__img'); a.href = it.url;
        if (it.img) { var im = document.createElement('img'); im.src = it.img; im.alt = ''; im.loading = 'lazy'; im.width = 120; im.height = 120; a.appendChild(im); }
        var n = card.querySelector('.lige-upsell__name'); n.href = it.url; n.textContent = it.title;
        var s = card.querySelector('.lige-upsell__price s'); if (it.compare) s.textContent = it.compare; else s.remove();
        card.querySelector('.lige-upsell__price span').textContent = it.price;
        var b = card.querySelector('[data-lige-up-add]');
        b.textContent = data.button || (LIGE_ES ? 'Añadir' : 'Add');
        b.setAttribute('data-id', it.id);
        b.setAttribute('aria-label', (data.button || (LIGE_ES ? 'Añadir' : 'Add')) + (LIGE_ES ? ': ' : ' ') + it.title);
        track.appendChild(card);
      });
      list.parentNode.insertBefore(box, list.nextSibling);
      upsellArrows(box);
      track.addEventListener('scroll', function () { upsellArrows(box); }, { passive: true });
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var nav = t.closest && t.closest('[data-lige-up-prev],[data-lige-up-next]');
    if (nav) {
      e.preventDefault(); e.stopPropagation();
      var box = nav.closest('.lige-upsell'), track = box.querySelector('[data-lige-up-track]');
      var from = track.scrollLeft;
      var x = from + (nav.hasAttribute('data-lige-up-next') ? 1 : -1) * track.clientWidth;
      track.scrollTo({ left: x, behavior: 'smooth' });
      /* terugval als soepel scrollen niet loopt */
      setTimeout(function () { if (track.scrollLeft === from) track.scrollLeft = x; upsellArrows(box); }, 450);
      return;
    }
    var add = t.closest && t.closest('[data-lige-up-add]');
    if (!add) return;
    e.preventDefault(); e.stopPropagation();
    if (ligeUpBusy) return;
    ligeUpBusy = true; add.classList.add('is-busy'); add.disabled = true;
    fetch(root() + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(add.getAttribute('data-id')), quantity: 1 }] })
    }).then(function (r) { return r.json(); })
      .then(function () {
        refreshCount();
        if (window.kachingCartApi && window.kachingCartApi.refreshCart) window.kachingCartApi.refreshCart();
      })
      .catch(function () {})
      .then(function () { ligeUpBusy = false; add.classList.remove('is-busy'); add.disabled = false; setTimeout(renderUpsell, 500); });
  }, true);
  new MutationObserver(function (muts) {
    if (ligeUpQueued || !upsellData()) return;
    for (var i = 0; i < muts.length; i++) {
      var tg = muts[i].target;
      if (tg && tg.closest && tg.closest('.lige-upsell')) continue;
      ligeUpQueued = true;
      setTimeout(function () { ligeUpQueued = false; renderUpsell(); }, 30);
      return;
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- start ---------- */
  function init(scope) {
    placeRating();
    (scope || document).querySelectorAll('.lige-ann').forEach(function (el) {
      if (el.__ligeAnn) return; el.__ligeAnn = true; initMarquee(el);
    });
    (scope || document).querySelectorAll('[data-lige-header]').forEach(function (el) {
      if (el.__lige) return; el.__lige = true; initHeader(el); initCartTimer(el);
    });
    (scope || document).querySelectorAll('[data-lige-product]').forEach(function (el) {
      if (el.__lige) return; el.__lige = true; el.__ligeProduct = new LigeProduct(el);
    });
    (scope || document).querySelectorAll('[data-lige-ba]').forEach(function (el) {
      if (el.__lige) return; el.__lige = true; initBeforeAfter(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Theme Editor: secties opnieuw initialiseren na bewerken. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* Teller bijwerken als de lade van het thema of Kaching de wagen wijzigt. */
  document.addEventListener('cart:updated', refreshCount);
  document.documentElement.addEventListener('cart:updated', refreshCount);
})();
